export const columns = [
  {
    title: '排序',
    dataIndex: 'list_order',
    scopedSlots: { customRender: 'list_order' },
    width: '150px',
  },
  {
    title: '编号',
    dataIndex: 'id',
  },
  {
    title: '分类名称',
    dataIndex: 'name',
  },

  {
    title: '状态',
    dataIndex: 'status',
    scopedSlots: { customRender: 'status' },
  },
  {
    title: '操作',
    dataIndex: 'operation',
    scopedSlots: { customRender: 'operation' },
  },
];

export const formData = [
  {
    name: 'parent_id',
    lable: '上级分类',
    lableCol: 4,
    wrapperCol: 18,
  },
  {
    name: 'name',
    lable: '分类名称',
    lableCol: 4,
    wrapperCol: 18,
  },

  {
    name: 'list_order',
    lable: '排序',
    lableCol: 4,
    wrapperCol: 18,
  },
];